import { useRive } from "@rive-app/react-canvas";
import { Fit, Layout, Alignment } from "@rive-app/canvas";
import { riveRegistry, type RiveRegistryKey } from "../../../assets/animations/riveRegistry/riveRegistry";

export const useAnimationRive = (riveKey: RiveRegistryKey = "notFound") => {
  const selectedRive = riveRegistry[riveKey];
  const src = selectedRive.file;

  const common = {
    src,
    autoplay: true,
    layout: new Layout({
      fit: Fit.Fill,
      alignment: Alignment.Center,
    }),
  } as const;

  const { RiveComponent } = useRive(
    "stateMachine" in selectedRive ? { ...common, stateMachines: selectedRive.stateMachine } : { ...common, animations: selectedRive.animations },
  );

  return { RiveComponent };
};
